import { gql } from "@apollo/client";

export const CATEGORYS = gql`
  query Categorys($franchise_id: Float!) {
    Categorys(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export default CATEGORYS;
